/* Toolbar owns the trigger; the shared drawer owns geometry, focus and motion.
 * Defined only with that controller in place: until then the snippets' link
 * and in-page filters (styled on collection-toolbar:not(:defined)) stay. */
if (!customElements.get('collection-toolbar') && window.AsansaraDrawer) {
  customElements.define('collection-toolbar', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const form = this.closest('form');
      form?.addEventListener('submit', () => {
        form.querySelectorAll('input[type="number"]').forEach((input) => { input.disabled = !input.value; });
      }, options);
      const toggle = this.querySelector('[data-filters-toggle]');
      const dialog = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
      if (!dialog) return;
      this.drawer = new window.AsansaraDrawer(dialog, '[data-filters-close]');
      toggle.addEventListener('click', () => this.drawer.open(toggle), options);
    }

    // Settles once the drawer has slid out; collection-products waits for it before swapping the markup.
    closeFilters() {
      return this.drawer?.close();
    }

    disconnectedCallback() {
      this.events.abort();
      this.drawer?.destroy();
    }
  });
}
